import { render, staticRenderFns } from "./LmDocumentRecipients.vue?vue&type=template&id=0ae4a985"
import script from "./LmDocumentRecipients.vue?vue&type=script&lang=js"
export * from "./LmDocumentRecipients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports